<!--  -->
<template>
   <el-header height="100px">
      <div class="top">
        <div class="top-con clearFix">
          <div class="left fl">
            <img class="fl" src="@/assets/images/logo.png" alt="" />
          </div>
          <div v-if="!isLogin" class="right fr">
            <a href="http://linglan.com/station/index/index" class="item fl"
              >返回首页</a
            >
            <span v-if="userInfo"  @click="logout" class="item fl">退出</span>
          </div>
        </div>
      </div>
    </el-header>
</template>

<script>
import { userUrl } from '@/config/deployUrl'
export default {
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  data() {
    return {};
  },
  methods:{
    logout() {
      console.log(this.userInfo)
      let reqdata = {
        userid:this.userInfo.userId
      };
      this.$request
        .post("/api/login/pcLogout", reqdata,'',userUrl)
        .then((res) => {
          console.log("登录")
          console.log(res)
          sessionStorage.setItem("token",null)
          // sessionStorage.setItem("code",this.$route.query.code)
          sessionStorage.setItem("userInfo",null)
          this.$router.push('/login')
          //  this.getMyCourseList()
        });
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
};
</script>
<style scoped>
/* @import url(); 引入css类 */
/deep/ .el-header {
  padding: 0px;
}
.item{
  cursor: pointer;
}
</style>